var finansudd = finansudd || {};

finansudd.submenu = new function(){

    var self = this;

    this.init = function (selector) {

    	var $activeListItem = selector.find('li.current');

    	// Add class to nearest parent li to apply arrow
    	if (!$activeListItem.hasClass('has-sub')) {
        	$activeListItem.parents('li').first().addClass('active-sub');
    	}

        // Add class to level-1 item to apply background-color to the whole menu section
       	$activeListItem.parents('li.sub-item-level-1').first().addClass('is-open');

	};

};